import { Component, Input, OnInit } from '@angular/core';
import {Stay} from '../../api/model/reservation/stay.model';
import {Hotel} from '../../api/model/hotel/hotel.model';

@Component({
  selector: 'checkin-checkout-dates',
  templateUrl: './checkin-checkout-dates.component.html',
  styleUrls: ['./checkin-checkout-dates.component.scss']
})
export class CheckinCheckoutDatesComponent implements OnInit {
  @Input() messages;
  @Input() stay: Stay;
  @Input() hotel: Hotel;

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/checkin-checkout-dates/checkin-checkout-dates.component.ts